module.exports = __webpack_public_path__ + "media/brand/yoojo-logo-093004e7.svg";